import { render, staticRenderFns } from "./OrderDetailsEdit.vue?vue&type=template&id=6166e6ac"
import script from "./OrderDetailsEdit.vue?vue&type=script&lang=js"
export * from "./OrderDetailsEdit.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailsEdit.vue?vue&type=style&index=0&id=6166e6ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports